import type { UiMetric } from "../types";

export function MetricBar({ metric, onSelect }: { metric: UiMetric; onSelect?: (metric: UiMetric) => void }) {
  const content = (
    <>
      <span className="metric-bar__label">{metric.label}</span>
      <strong className="metric-bar__value">{metric.applicable ? metric.value : "N/A"}</strong>
      <span className="metric-bar__track" aria-hidden="true">
        <span className="metric-bar__fill" style={{ width: `${metric.applicable ? metric.value : 0}%` }} />
      </span>
    </>
  );
  return onSelect ? (
    <button type="button" className="metric-bar" onClick={() => onSelect(metric)} aria-label={`${metric.label}: ${metric.applicable ? metric.value : "not applicable"}. View calculation.`}>{content}</button>
  ) : <div className="metric-bar">{content}</div>;
}
